import { ButtonERP, Dialog } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"

const ModalContraAsiento = ({
  visible,
  isloadingContrasiento,
  onConfirm,
  onCancel,
}: {
  visible: boolean
  isloadingContrasiento?: boolean
  onConfirm?: () => void
  onCancel: () => void
}) => {
  const { t } = useTranslation()
  return (
    <Dialog
      visible={visible}
      draggable
      baseZIndex={30}
      closable={false}
      maskClassName='!tw-z-30'
      keepInViewport={false}
      onHide={onCancel}
      header={
        <>
          <div className='tw-rounded-full tw-w-24 tw-h-24 tw-flex tw-justify-center tw-items-center  tw-bg-background tw-mx-auto tw-mt-4 tw-mb-4 !tw-p-0'>
            <div className='tw-bg-white tw-w-16 tw-h-16 tw-border tw-border-neutral-10 tw-rounded-full tw-flex tw-items-center tw-justify-center !tw-p-0'>
              <FontAwesomeIcon
                icon={["fal", "triangle-exclamation"]}
                className='tw-font-bold tw-h-8 tw-w-8 tw-text-danger'
              />
            </div>
          </div>
          <p className='tw-text-lg tw-text-center tw-font-medium tw-text-primary tw-mb-3'>
            {t("diario.modal.generateContraAsiento")}
          </p>
        </>
      }
      className='tw-w-100 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      footer={
        <div className='tw-mt-6 tw-flex tw-items-center tw-justify-center tw-gap-4'>
          <ButtonERP
            customize={{
              type: "white",
              size: "md",
            }}
            onClick={() => {
              onCancel()
            }}
            label={`${t("diario.modal.cancelButton")}`}
          />
          <ButtonERP
            customize={{
              type: "danger",
              size: "md",
            }}
            loading={isloadingContrasiento}
            disabled={isloadingContrasiento}
            onClick={onConfirm}
            label={`${t("diario.modal.confirmAndGeneratLabel")}`}
          />
        </div>
      }
    >
      <div className='tw-text-center'>
        {t("diario.modal.contraAsientoText")}
      </div>
    </Dialog>
  )
}

export default ModalContraAsiento
